module.exports = __webpack_public_path__ + "static/media/book_saldatura.64a3a9e2.png";